import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Multiselect from 'vue-multiselect';

export default {
  name: 'sorter-handover',
  components: {
    VueElementLoading,
    BasicSelect,
    Multiselect
  },
  props: [],
  data () {
    return {
      isLoading: false,
      hubLoading:'',
      hubid: "",
      hubname : "",
      hubdetailsarray: [],
      HubNameData: [],
      showmodel : false,
      routemode : '',
      groups :'',
      groupArr : [],
      mappedgrouplist: [],
      modelArr: [],
      allGroupData: [],
      checked: [],
      destData: [],
      addmodalShow: false,
      fullhubname : '',
      mapgroups : false,
      hubData: {
				value: "",
				text: ""
			},
      HubName:'',
      DestHubNameData:[],
      groupNo : "",
      routemode1:"",
      groupNamesarray : [],
      groupname : [],
      groupName : "",
      allGroups :[],
      groupnameerror :"",
      routemoderror :"",
      addnewmodalShow: false,
      groupLoading : ""
    }
  },
  computed: {},
  filters: {
  },
  mounted () {
    let userdetailEncrypt = window.localStorage.getItem('userdetail')
    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    let userdetail = JSON.parse(plaintext)
    this.useremail = userdetail[0].email;
    this.getHubName();
  },
  methods: {
    labelWithGroup({ groupname,groupno}){
      return `${groupname}`;
    },
    searchGroups(){
      this.allGroupData=[];
      this.isLoading = true;
        this.input =({
        sorterHubId:this.hubid
      })
      if(this.routemode){
        this.input.routeMode = this.routemode
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getSorterLHHadoverMappingDetails',
          'data': this.input,
          headers: {
          'authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.showmodel = true;
            this.$alertify.success(result.data.ReturnMessage)
            let j = 0; let list = []; let dlist = [];
            let hData = result.data.ResponseData;
            for (const element of hData) {
              if (j < 4) {
                list.push({
                  groupNo: element.groupno,
                  groupName : element.groupname
                });
              } else {
                dlist.push(list);
                list = []
                list.push({
                  groupNo: element.groupno,
                  groupName : element.groupname
                });
                j = 0;
              }
              j++;
              if (element.isgroupSelected == true) {
                (this.groupArr.indexOf(element.groupno) === -1) ? this.groupArr.push(element.groupno) : '';
                this.checked[element.groupno] = true;
              }
              this.destData.push({
                groupno: element.groupno,
                groupName : element.groupname
              });
              const allH = this.allGroupData.some(el => el.groupno === element.groupno);
              if (!allH) {
                this.allGroupData.push({
                  groupNo: element.groupno,
                  groupName : element.groupname
                });
              }
            }
            this.modelArr = (this.modelArr.length > 0) ? this.modelArr : this.groupArr;
            dlist.push(list);
            this.mappedgrouplist = dlist;
          } else {
            this.isLoading = false
            this.showmodel=false;
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
          this.showmodel=false;
          this.isLoading = false
        })
    },
    updateCheckHubs(event) {
      this.checked[event.target.id] = event.target.checked;
      if (event.target.checked == false) {
        this.modelArr = this.modelArr.filter(el => el != event.target.id)
      } else {
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(event.target.id) : '';
      }
    },
    onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					}
        	this.searchGroups();
				}).catch((err) => {
					console.log('errors exist', this.errors);
				});
		},
    openstatusmodel(){
      this.addmodalShow = true;
    },
    opennewstatusmodel(){
      this.addnewmodalShow = true;
    },
  mapnewgroups() {
    this.$validator.validateAll()
      .then((result) => {
        if (!result) {
          return false;
        }
          this.mapgroups= true;
      }).catch((err) => {
        console.log('errors exist', this.errors);
      });
     },
    addnewgroups(){
      this.groupnameerror="";
      if (!this.routemode1) {
        this.routemoderror = 'Please select Routemode'
        return false;
      }
      if (!this.allGroups || this.allGroups.length <= 0) {
        this.groupnameerror = 'Please select Group'
        return false;
      }
      this.isLoading = true;
      let groupArray = []
      groupArray = this.allGroups.map((elem)=>{ return { groupNo: elem.groupno, groupName: elem.groupname }; });
      this.input = {
        sorterHubId: this.hubid,
        sorterHubName : this.hubname,
        routeMode : this.routemode1,
        groupNoAndgroupName :groupArray,
        createdBy: this.useremail,
        isUpdate: false,
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + "mapSorterLHHandovergroupDetails",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.resetFeilds();
            this.$alert(result.data.ReturnMessage, "", "success");
          } else {
            this.isLoading = false;
            this.$alert(result.data.ReturnMessage, "", "error");
          }

        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    closeStatusModal() {
      this.addmodalShow = false
    },
    closeNewStatusModal(){
        this.addnewmodalShow = false
    },
    updateMappedHubs(){
    let groupArray = this.allGroupData.filter((elem) => this.modelArr.find((el) => elem.groupNo == el));
    this.input = {
      sorterHubId: this.hubid,
      sorterHubName : this.hubname,
      routeMode : this.routemode,
      groupNoAndgroupName :groupArray,
      createdBy: this.useremail,
      isUpdate: true,
    }
    axios({
      method: 'POST',
      'url': apiUrl.api_url_hubops + "mapSorterLHHandovergroupDetails",
      'data': this.input,
      headers: {
        'Authorization': "authkey xB84JJ89Hd25"
      }
    })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.$alert(result.data.ReturnMessage, "", "success");
          this.resetFormFeilds();
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.error(error)
      })
    },
    closeWindow(){
      this.routemode1="";
      this.allGroups=[];
      this.groupNamesarray=[]
      this.mapgroups = false
      this.searchGroups();
    },
    resetFeilds(){
      this.routemode1=''
      this.allGroups=[];
      this.groupNamesarray=[]
    },
    resetFormFeilds(){
      this.modelArr = [];
      this.checked = [];
      this.mappedgrouplist= [];
      this.allGroupData= [];
      this.destData = [];
      this.groupArr= [];
      this.searchGroups();
    },
    selectedHub(hubData) {
			this.hubData = hubData
      this.hubid = hubData.value
      this.hubname = hubData.text.split('(')[0].trim()
			this.fullhubname = hubData.text
		},
    selectRoutemode(){
        this.routemoderror="";
        this.allGroups=[];
        this.groupNamesarray=[]
        this.getGroupName();
    },
    selectGroup(){
      this.groupnameerror="";
    },
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          this.hubdetailsarray = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },
    getGroupName() {
    this.groupLoading = 'Loading Groups...'
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input ={
        routeMode : this.routemode1
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getAllGroupsRouteModeWise',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }

        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.groupNamesarray = result.data.ResponseData
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          console.error(error)
        })
    },
    resetData(){
      this.$validator.reset();
      this.hubid='';
      this.hubData={
        value:"",
        text:""
      },
      this.routemode='';
      this.showmodel=false;
      this.mapgroups=false;
      this.destData = [];
      this.modelArr = [];
      this.checked = [];
      this.groupNo = "";
      this.routemode1="";
      this.groupNamesarray = [];
      this.groupname = [];
      this.groupName = "";
      this.allGroups =[];
      this.groupnameerror ="";
      this.routemoderror ="";
      this.addnewmodalShow= false;
      this.isLoading=false;
      this.hubLoading='';
      this.groups ='';
      this.groupArr= [];
      this.mappedgrouplist= [];
      this.allGroupData= [];
      this.addmodalShow=false;
      this.fullhubname ='';
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/SorterHandover/SorterHandover.js